<!--
  用户用手机号密码登录后，如果未绑定公众号，则弹出绑定公众号表单
 -->
<template>
  <div class="bind_wechat">
    <div class="txt_box">
      <h1>
        <i class="iconfont iconziyuan57"></i>
        <span>请使用微信扫码关注并绑定账号</span>
      </h1>
    </div>
    <div class="form_wrapper">
      <el-image v-loading="qrCodeLoading" class="code_img" :src="qrCodeBase64"></el-image>
    </div>
  </div>
</template>

<script>
import * as api from '~/api'
export default {
  data () {
    return {
      // 获取二维码loading
      qrCodeLoading: false,
      // 二维码base64
      qrCodeBase64: '',
      // 二维码唯一标识 轮询用
      qrCodeScene: '',
      // 二维码五分钟失效 记录住获取到二维码时的事件
      getQrCodeTime: '',
      // 定时器
      askInterval: null
    }
  },
  created () {
    // 获取绑定二维码
    this.getBindQrcode()
  },
  methods: {
      // 获取登录微信公众号二维码信息
      getBindQrcode () {
      this.qrCodeLoading = true
      api.getBindQrcode().then(res => {
        if (res.data.code === 0) {
          console.log('获取登录二维码', res.data.data)
          this.qrCodeBase64 = res.data.data.src
          this.qrCodeScene = res.data.data.scene
          this.getQrCodeTime = new Date().getTime()

          this.askInterval && clearInterval(this.askInterval)
          if (this.$parent && this.$parent.visible) {
            this.askInterval = setInterval(() => {
              // 查询扫描状态
              this.askBind()
            }, 1000)
          }   
        } else {
          this.$message.error(res.data.message)
        }
        this.qrCodeLoading = false
      }).catch((error) => {
        console.log(error)
        this.$message.error(`网络错误，请检查网络设置`)
        this.qrCodeLoading = false
      })
    },
    // 轮询获取二维码扫描信息
    askBind () {
      api.askBind(this.qrCodeScene).then(res => {
        if (res.data.code === 0) {
          console.log('轮询获取', res.data.data)
          let status = res.data.data.status
          if (status === 'waiting') {
            let curDate = new Date().getTime()
            let overTime = (curDate - this.getQrCodeTime) / 1000
            // 间隔了五分钟的话，重新获取二维码
            if (Math.abs(overTime) > 300) {
              clearInterval(this.askInterval)
              this.getBindQrcode()
            }
          } else if (status === 'done') {
            clearInterval(this.askInterval)
            // 重新获取用户信息
            this.$store.commit('SET_USER_INFO', res.data.data)
            // 已经绑定过了 关闭弹窗
            this.$emit('closeDialog')
            this.$bus.emit('loginSuccess')
          }
        } else {
          // 关闭弹窗
          clearInterval(this.askInterval)
          this.$message.error(res.data.message)
        }
      }).catch((error) => {
        clearInterval(this.askInterval)
        console.log(error)
        this.$message.error(`网络错误，请检查网络设置`)
      })
    },
    // 关闭
    closeDialogCallback () {
      this.askInterval && clearInterval(this.askInterval)
      console.log('关闭了')
    }
  }
}
</script>

<style lang="scss" scoped>
  .bind_wechat {
    padding: 30px 63px 20px 60px;
    .txt_box {
      & > h1 {
        margin-bottom: 10px;
        text-align: center;
        & > span {
          font-size:14px;
          font-weight:normal;
          color: #000000;
        }
      }
    }
    .form_wrapper {
      display: flex;
      justify-content: center;
      margin-top: 30px;
      .code_img {
        width: 160px;
        height: 160px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/header/form-dialog/bind-wechat.vue